import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import indsacvision from "../Images/indsac-vision.jpg";
import indsaccrm1 from "../Images/indsac-crm1.jpg";
import SEO from "../components/SEO";  

export default function OurStory() {
  return (
    <>
      <SEO  
        title="Our Story - AI ERP & CRM Company | EnteliPro"
        description="Learn the story behind EnteliPro - the AI ERP and CRM software company. Discover our vision, mission, and how we're transforming businesses with intelligent solutions."
        keywords="Our Story, About EnteliPro, AI ERP Company, CRM Company, Business Solutions, Digital Transformation, Company Vision"
        canonical="https://www.entelipro.com/ourstory"
        ogImage="https://www.entelipro.com/static/media/indsac-crm1.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Our Story</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsaccrm1}
                  alt="EnteliPro AI ERP and CRM Software Company"  
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}> 
                  Our Story - Building the Future of AI ERP & CRM
                </h1>
                <p className="para">
                  Customer relationship management software is a special system
                  with one primary purpose: improving relationships with clients
                  by providing businesses with smart tools to effectively
                  develop a successful strategy. CRM software can advance
                  crucial business operations, such as marketing, service and
                  sales activities, to improve customer experience and loyalty
                  from initial contact to repeat purchases.
                </p>
                <br />
                <p className="para">
                  If your main concern is sales, you can make use of performance
                  tracking for individual sales agents. The CRM software focuses
                  on putting customer needs first and delivering a superior,
                  more personalized customer experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="cwp4-text col-xl-6">
                <h2>Our Vision</h2> 
                <p className="para">
                  TO BRING POSITIVE TRANSFORMATION TO EVERY LIFE WE TOUCH
                </p>
                <br />
                <p className="para">
                  To be recognized as the industry leader driving modernization
                  in IT services and the developing world and to be the centre
                  of modern Research and Development in IT sector.
                </p>
              </div>
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={indsacvision}
                  alt="EnteliPro Vision - Positive Transformation Through AI"  
                  className="img-responsive "
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>How CRM is Useful for a Company?</h3>
              <p className="para">
                Customer relationship management systems can be easily
                customized to meet the specifications needed of any business
                type and size.
                <br />
                <br />
                1. B2B: From managing an account's contact information to
                staying up to date with business deals, payments, and reports,
                B2B companies do best with a sales CRM in place.
                <br />
                <br />
                2. B2C: B2C companies have shorter customer life cycles, and
                they typically require a solution that is more direct and less
                time-consuming.
                <br />
                <br />
                3. SMBs: SMBs are not small and medium businesses but smart and
                modern businesses. There's no truth to the common mistake that
                cloud CRM is too expensive and complicated for SMBs.
                <br />
                <br />
                4. Enterprises: Advanced CRM features like workflow management,
                advanced analytics, sales, and marketing automation, can help
                reduce the time salespeople spent on mundane tasks.
              </p>
              <br />
              <br />

              <h3>Benefits of CRM</h3>
              <p className="para">
                1. A CRM system manages all your contacts and aggregates lead
                and customer information to build profiles of everyone you
                interact with.
                <br />
                <br />
                2. Streamlining and improving the sales process, building a
                sales pipeline, automating tasks, and analyzing your sales data
                will inevitably lead to one outcome: increased sales and sales
                productivity.
                <br />
                <br />
                3. Retention and rates are extremely important determiners for a
                company's success; customer churn is a major obstacle to
                business growth.
                <br />
                <br />
                4. Analytical CRM tools make your data available, intelligible,
                and relevant to your business needs. All your sales data,
                finance data, and marketing data flow into CRM to become
                visible metrics.
                <br />
                <br />
                5. Having all your major day-to-day business functions in one
                place makes for better workflow, an easier association between
                team members, and better project management.
                <br />
                <br />
              </p>
              <br />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}